import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../common/axios';

const BiddingPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/getbidding'); 
        if(res.data.success){
          setData(res.data.data);
        }
      } catch (error) {
        console.error(t('bidding.serviceError'), error);
      }
    };
    fetchData();
  }, []);
  
  return (
    <div className='app-content flex-column-fluid'>
      <div className='app-container container-xxl'>
        <div className="card mb-5 mb-xl-8">
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold fs-3 mb-1">{t('nav.bidHistory')}</span>
              <span className="text-muted mt-1 fw-semibold fs-7">{t('bidding.newEvaluationStatus', { count: data.length })}</span>
            </h3>
            <div className="card-toolbar"></div>
          </div>
          <div className="card-body py-3">
            <div className="table-responsive">
              <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                <thead>
                  <tr className="fw-bold text-muted">
                    <th className="min-w-150px">{t('bidding.projectName')}</th>
                    <th className="min-w-150px">{t('nav.bidManagement')}</th>
                    <th className="min-w-120px">{t('bidding.bidResult')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 && data.map((v, index) => (
                    <tr key={index}>
                      <td className="text-dark fw-bold text-hover-primary fs-6">{v.ugenProjectName}</td>
                      <td className="text-dark fw-bold text-hover-primary fs-6">{v.BiddingTitle}</td>
					  <td>
                        <span className={v.BidResultSYS === "성공" ? "badge badge-light-success" : "badge badge-light-warning"}>
                          {t(`bidding.${v.BidResultSYS === "성공" ? "success" : "failure"}`)}
                        </span>
                      </td>
                      <td className="text-end"></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingPage;
